module.exports = __webpack_public_path__ + "static/img/answer5.0a8cb7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/answer5.png
// module id = C5tD
// module chunks = 1